import { render, staticRenderFns } from "./Create_Campaign.vue?vue&type=template&id=24c83f34&scoped=true&"
import script from "./Create_Campaign.vue?vue&type=script&lang=js&"
export * from "./Create_Campaign.vue?vue&type=script&lang=js&"
import style0 from "./Create_Campaign.vue?vue&type=style&index=0&id=24c83f34&lang=scss&scoped=true&"
import style1 from "./Create_Campaign.vue?vue&type=style&index=1&id=24c83f34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c83f34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VApp,VBtn,VCol,VCombobox,VIcon,VRow,VSelect})
